module.exports = __webpack_public_path__ + "static/media/kudos-heart-icon.84602215.svg";